import * as React from 'react';
import autobind from "autobind-decorator";

import { AutocompleteView } from 'src/core/ui/autocomplete/autocomplete.view';

interface ClientTitleEditorViewProps {
    label?: string;
    value: string | null;
    onChanged: (number: string | null) => void;
    mode: ControlMode;
    titleQuery: DropdownRequest<AutocompleteSummary>;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientTitleEditorView extends React.Component<ClientTitleEditorViewProps, any> {
    public constructor(props) {
        super(props);
    }

    @autobind
    protected onChanged(value: any) {
        if (value != null)
            this.props.onChanged(value.value);
    }

    public render() {
        return (
            <AutocompleteView
                onGetErrorMessage={this.props.onGetErrorMessage}
                required={this.props.required}
                request={this.props.titleQuery}
                label={this.props.label === undefined ? 'Title' : this.props.label}
                disabled={this.props.mode == 'display'}
                model={this.props.value} onChanged={item => this.onChanged(item)} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clienttitle-editor.view.tsx